"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.status.active': 'Active',
    'settings.status.inactive': 'Inactive',
    'settings.status.enabled': 'Enabled',
    'settings.status.disabled': 'Disabled',
    'settings.status.connected': 'Connected',
    'settings.status.notConnected': 'Not Connected',
    'settings.status.authenticated': 'Authenticated',
    'settings.status.notAuthenticated': 'Not Authenticated',
};
